<template>
  <v-icon 
    size="14" 
    :class="['cursor', {'animation-isExpanded': isExpanded}, {'animation-isNotExpanded': !isExpanded}]"
    :color="color"
  >
    {{icon}}
  </v-icon>
</template>

<script>

export default {
  name: 'ExpandedIcon2',
  props: {
    icon: {type: String, default: 'fa-solid fa-angle-up'},
    isExpanded: {type: Boolean, required: true},
    color: {type: String, default: '#0079CB'}
  }
}
</script>

<style scoped>
.cursor {
  cursor:  pointer !important;
}
.animation-isExpanded {
  transition: transform 0.4s ease-in-out;
  transform: rotate(0deg);
}

.animation-isNotExpanded {
  transition: transform 0.4s ease-in-out;
  transform: rotate(-180deg);
}
</style>
